import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * The 20px circle that marks an issue row as ticked in selection mode: an empty
 * grey ring, or a filled primary circle with a check. The same circle the
 * report's Add issues picker draws. See [[issue-item.spec]] § Selection mode.
 */
export function IssuePickCircle({
  selected,
  className,
}: {
  selected: boolean;
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      data-slot="issue-pick-circle"
      className={cn(
        "flex size-5 shrink-0 items-center justify-center rounded-full border",
        selected
          ? "border-primary bg-primary text-primary-foreground"
          : "border-muted-foreground/40",
        className,
      )}
    >
      {selected && <Check className="size-3" />}
    </span>
  );
}

/** What a host passes a row to put it in selection mode. */
export interface IssueRowSelection {
  selected: boolean;
  onToggle: () => void;
}
